import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import PageSection from '../../design-system/PageSection';
import Modal from '../../components/Modal';
import { HeadingSection } from '../../design-system/Headings';
import { Button } from '../../design-system/Buttons';
import phrasesType from '../../proptypes/phrases';
import Paragraph from '../../design-system/Paragraph';
import Container from '../../design-system/Containers';
import { ResponsiveImage } from '../../design-system/Images';
import { ssColorCyan } from '../../constants/style-constants';
import useCookie from '../../hooks/useCookie';
import { showDossierPurchaseSuccessModalAction } from '../../actions/action-creators';

const COOKIE_KEY = 'premium-payment-success-modal';

const ModalGradient = () => <div className="ss_modal-background" />;

export default function PremiumPaymentSuccessModal({
  phrases,
  visible,
  onCloseClick,
  modalDismissedCookieValue,
}) {
  const [cookieValue, setCookie] = useCookie(COOKIE_KEY, null);

  const dispatch = useDispatch();

  useEffect(() => {
    if (visible && cookieValue) {
      dispatch(showDossierPurchaseSuccessModalAction());
    }
  }, [visible, cookieValue, dispatch]);

  if (cookieValue === modalDismissedCookieValue) return null;

  const onClose = () => {
    const expiryDate = new Date();
    expiryDate.setFullYear(new Date().getFullYear() + 1);

    setCookie(modalDismissedCookieValue, { expires: expiryDate });
    onCloseClick();
  };

  return (
    <Modal show={visible} onClose={onClose}>
      <div className="ss_modal">
        <PageSection container={false} center>
          <ModalGradient />
          <div className="ss_modal_content">
            <Container center myLg>
              <div
                style={{
                  margin: '30px',
                  position: 'relative',
                  width: '50px',
                }}
              >
                <div
                  style={{
                    backgroundColor: `${ssColorCyan}`,
                    filter: 'blur(40px)',
                    height: '100%',
                    left: '0',
                    position: 'absolute',
                    right: '0',
                    top: '0',
                    width: '100%',
                  }}
                />
                <div
                  style={{
                    position: 'relative',
                  }}
                >
                  <ResponsiveImage
                    alt=""
                    src="//images.ctfassets.net/gtqjh9j40j4m/38otjbEbmjqQtXMDYnOUNh/0f3681893b194a72d24dac80cbf7df6b/tick.svg"
                  />
                </div>
              </div>
              <HeadingSection el="h2" py0 my0>
                {phrases.title}
              </HeadingSection>
              <Paragraph>{phrases.description}</Paragraph>
              <Button onClick={onClose}>
                {phrases.buttonLabel}
                {' '}
→
              </Button>
            </Container>
          </div>
        </PageSection>
      </div>
    </Modal>
  );
}

PremiumPaymentSuccessModal.propTypes = {
  phrases: phrasesType.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  modalDismissedCookieValue: PropTypes.string.isRequired,
};
